import { useBrowseLink } from 'hooks/useBrowseLink';
import { analytics } from 'utils/analytics';
import {
    CtaGoal,
    CtaType,
    InteractionSource,
} from 'utils/analytics/AnalyticsV2Service.generated';
import { useCreatorContext } from 'controllers/business/Creator/Creator.controller';
import { DefaultCreatorConfig } from 'controllers/business/Creator/helpers/misc.helpers';
import { RoutePaths } from 'types/enums';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';

export const useCreatorFooter = (): {
    browseLoop: string;
    freeSamplesLoop: string;
    showCreatorFooter: boolean;
    handleAddSampleClick: () => void;
    handleFreeSamplesClick: () => void;
} => {
    const { closeCreator, state } = useCreatorContext();
    const samplesCount = state.samplesInSession.size;
    const browseLoop = useBrowseLink();
    const freeSamplesLoop = useBrowseLink({ showFreeOnly: true });
    const showCreatorFooter = samplesCount < DefaultCreatorConfig.MAX_TRACKS;

    const toLocalizedPath = useToLocalizedPath();

    const creatorBaseClick = () => {
        // make sure we load at top of the page
        window.scrollTo(0, 0);
        closeCreator();
    };

    const handleAddSampleClick = () => {
        creatorBaseClick();

        analytics.trackCTAClicked({
            ctaGoal: CtaGoal.BrowseSamples,
            ctaType: CtaType.Button,
            interactionSource: InteractionSource.CreatorAction,
            ctaText: 'Add a sample',
            ctaDestination: toLocalizedPath(`/${RoutePaths.Browse}?Type=loop`),
        });
    };

    const handleFreeSamplesClick = () => {
        creatorBaseClick();

        analytics.trackCTAClicked({
            ctaGoal: CtaGoal.BrowseFreeSamples,
            ctaType: CtaType.PlainText,
            interactionSource: InteractionSource.CreatorAction,
            ctaText: 'Browse free samples here.',
            ctaDestination: 'browse?textSearch=Free&Type=loop',
        });
    };

    return {
        browseLoop,
        showCreatorFooter,
        handleAddSampleClick,
        freeSamplesLoop,
        handleFreeSamplesClick,
    };
};
